// 旋转方向
let rotateDirection = {
  "1": "L",
  "0": "R",
}


/**
 * 步骤模板
 * @param type 食谱类型
 * @param config 步骤配置项
 * @returns {string|null}
 */
export function getTemplate(type, config) {
  if(type === "SOUP") { // 汤机
    return `${config.temperature}℃/${config.minute}m${config.second}s/V${config.rotateSpeed}/${rotateDirection[config.rotateDirection]};`;
  } else if(type === "AIR_FRYER") { // 空炸
    return `${config.temperature}℃/${config.minute}m${config.second}s/V${config.rotateSpeed}/${config.rotateDirection};`;
  }
  // 厨师机
  return `${config.temperature}℃/${config.minute}m${config.second}s/V${config.rotateSpeed}/${config.rotateDirection};`;
  // return "";
}

// 汤机/空炸工作模式原理
export const TH_WORK_MODE = {
  "BOIL_WATER": "它是相同的电水壶功能，温度默认为100度，无法设置时间，这个程序将在温度达到100度时结束。",
  "TURBO": "就像脉搏的作用一样，默认速度为12速，1分钟，它是用来混合。",
  "FOOD_PROCESSOR": "当需要用圆盘研磨或切片，或用刀片切碎时，请选择此方式。工作参数:速度3-5/时间0s-lmin",
  "ADAPTED_COOKING": "对于没有明确规定的一般烹饪，可以选择此模式设置参数。",
  "KNEAD_TOUGH": "这是一个揉面团的功能。顺时针旋转27秒，停3秒，反转27秒，停3秒，共运行3分钟。",
  "STEAM": "当温度到了95度后才会倒计时，同自动程序中的蒸汽程序",
  "SLOW_COOK": "该模式适用于一些需要低速长时间烹饪的食谱",
  "DESCRIPTION": "它是不需要任何设备操作的步骤",
  "WEIGHT": "这一步是为了放多少配料进行称重的步骤。",
  "CHOP": "用于绞肉机或剁碎。工作参数：速度1-12/时间10秒-4分钟。",
  "BROWN": "以设定的速度5秒开25秒停，但是加热程序一直工作",
  "SPECIAL_DIY_MODE": "烹饪时间/温度/速度跟普通模式一致，时间只有在到达设定温度后才会倒计时。",
  "WARNING": "提醒用户操作注意事项。",
  "ADAPTED_COOKING_HEAT": "对于没有明确规定的一般烹饪，可以选择此模式设置参数。0-100℃调用烧水的加热逻辑，100℃以上调用原来的DIY加热逻辑。",
  "AF_DIY": "对于没有明确规定的一般烹饪，可以选择此模式设置参数。多汁、多油的食材选择用空炸盘盛放；偏干性、体积大或需要不断翻面的食材用空炸锅直接加热。",
  "AF_AIR_FRYER": "适用炸薯条、薯片类的功能，可选择空炸锅或空炸盘盛放食材加热。",
  "AF_DESCRIPTION": "它是不需要任何设备操作的步骤",
  "AF_BAKE": "适用烤面包的功能，面包直接放于空炸锅中烘烤，烘烤过程进行翻面效果更佳。",
  "AF_DRUMSTICKS": "适用炸鸡腿的功能。直接放于空炸锅中，烘烤过程进行翻面效果更佳。",
  "AF_EGG_TART": "适用烤蛋挞的功能，放于空炸盘中烘烤",
  "AF_PIZZA": "适用烤披萨的功能，调好的披萨放于空炸锅中烘烤",
  "AF_DEHYDRATE": "适用对食物做脱水的功能，例如柠檬片，红枣等食材。",
  "AF_REHEAT": "适用对食物进行再次加热的功能。",
  "AF_CHICKEN_WING": "适用烤鸡翅的功能，放于空炸盘中烘烤",
  "AF_STEAK": "适用烤牛排的功能，放于空炸盘中烘烤，烘烤过程进行翻面效果更佳。",
  "AF_SEA_FOOD": "适用烤海鲜的功能，例如虾，鱼等食材，放于空炸盘中加热",
  "AF_VEGETABLE": "适用烤蔬菜类的功能，例如茄子，青菜等食材，放于空炸盘中加热",
  "AF_MUTTON_CHOP": "适用烤羊排，排骨的功能，放于空炸盘中烘烤，烘烤过程进行翻面效果更佳",
  "AF_WEIGHT": "对食材，调料进行称重。",
  "AF_WARNING": "提醒用户操作注意事项。",
  "FERMENT": "给牛奶发酵提供一个恒定温度的环境",
}


/**
 * 部分模式不显示属性配置
 */
export const TH_MODE_NO_CONFIG = [
  "WEIGHT",
  "AF_WEIGHT",
  "SM_WEIGHT",
  "DESCRIPTION",
  "AF_DESCRIPTION",
  "SM_DESCRIPTION",
  "O_DESCRIPTION",
  "WARNING",
  "AF_WARNING",
  "SM_WARNING",
]

/**
 * 根据传入的工作模式判断是否显示属性配置
 */
export function showConf(mode) {
  if(!mode) return false;
  return !TH_MODE_NO_CONFIG.includes(mode);
}

